import { Tabs, TabsProps } from 'antd';
import { FormattedMessage } from 'react-intl';
import LayoutComponent from '../../components/LayoutComponent/LayoutComponent';
import AccountCompanyComponent from './AccountCompanyComponent/AccountCompanyComponent';
import AccountUserComponent from './AccountUserComponent/AccountUserComponent';
import { useContext } from 'react';
import CustomContext from '../../contexts/CustomContext';

const UserProfilePage: React.FC = () => {
    /***HOOKS***/

    const { auth } = useContext(CustomContext);

    /***METHODS***/

    /***VISUAL***/

    let items: TabsProps['items'] = [
        {
            key: 'user',
            label: <FormattedMessage id="userProfile.user" />,
            children: <AccountUserComponent />,
            forceRender: true
        }
    ];
    if (auth && auth.companyId) {
        items = [
            ...items,
            {
                key: 'company',
                label: <FormattedMessage id="userProfile.company" />,
                children: <AccountCompanyComponent />,
                forceRender: true
            }
        ];
    }

    return (
        <LayoutComponent
            title={<FormattedMessage id="userProfile.title" />}
            menu="userProfile"
            path={[{ path: '/user-profile', name: <FormattedMessage id="userProfile.title" /> }]}
        >
            <Tabs defaultActiveKey="account" items={items} />
        </LayoutComponent>
    );
};
export default UserProfilePage;
